import styled from 'styled-components'
import { hideVisually } from 'polished'

const HideVisually = styled.span`
  ${hideVisually()}
`

export default HideVisually
